module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    class: {
      'modal-content': true,
      'modal-warning': true,
    }
  }, [_c('div', {
    staticClass: "modal-body text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.yes
    }
  }, [_vm._v("確定")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.no
    }
  }, [_vm._v("取消")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01ae535a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Confirm.vue
// module id = 1363
// module chunks = 1